import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Section';
import { painPoints } from '../data/painPoints';
export function PainGrid() {
  return <Section background="paper" labelledBy="pain-heading" data-id="element-191" data-mp="1zhroh4mfh7z9">
      <h2 id="pain-heading" className="mx-auto max-w-3xl text-center font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-192" data-mp="1undwzdavzkzv">
        If you teach Pilates, at least one of these will feel uncomfortably familiar:
      </h2>

      <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-193" data-mp="1goebgeio7m7x">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3.5 rounded-2xl border border-sage/15 bg-white p-5 shadow-card sm:p-6" data-id="element-194" data-mp="1bp2qetb9tukj">
            <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-flag-red" strokeWidth={2} aria-hidden="true" data-id="element-195" data-mp="17qlqouu6jmd5" />
            <p className="font-sans text-[15px] leading-[1.6] text-ink-soft sm:text-base" data-id="element-196" data-mp="323lc54l8rasc">
              {point}
            </p>
          </li>)}
      </ul>

      <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-2xl font-medium leading-snug text-ink sm:text-[28px]" data-id="element-197" data-mp="3l8ppmgfcfb1b">
        What if every one of these moments already had a protocol — question by question, page by
        page?
      </p>
    </Section>;
}